import { render, staticRenderFns } from "./tourdetails.vue?vue&type=template&id=35e36616&scoped=true&"
import script from "./tourdetails.vue?vue&type=script&lang=js&"
export * from "./tourdetails.vue?vue&type=script&lang=js&"
import style0 from "./tourdetails.vue?vue&type=style&index=0&id=35e36616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e36616",
  null
  
)

export default component.exports